var numeral = require('numeral');
var ptBR = require('../../../node_modules/numeral/languages/pt-br');

numeral.language('pt-br', ptBR);

module.exports = numeral;